import { Component, Input } from "@angular/core";
import { DocumentModel } from "@models/documents/documentmodel";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { DateTimeFormatPipe } from "@app/shared/pipes/date-time-format.pipe";

@Component({
    selector: "eff-document-details",
    templateUrl: "./eff-document-details.component.html",
    styleUrls: ["./eff-document-details.component.scss"],
    imports: [TranslatePipe, DateTimeFormatPipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffDocumentDetailsComponent {
    @Input() document: DocumentModel;
}
